






























































































































































































































































































































































































































































import Vue from 'vue';
import axios from 'axios';
import moment, { Moment } from 'moment-timezone';
import validator from 'validator';
import Datepicker from 'vuejs-datepicker';
import * as datepickerLanguages from 'vuejs-datepicker/dist/locale';
import {
  logError,
  getLowestUtilizedEntrance,
  rangeArray,
  checkAllowedLocation,
  apiPostRequest,
  getLocationTimezoneName,
  apiGetRequest,
} from '../../helpers';
import {
  OccupantTypeEntity,
  EntranceEntity,
  TimeslotEntity,
  ReservationEntity,
  LocationEntity,
  TimeslotSchedule,
  CreateRegularReservation,
  CreateRegularReservationAPIReturn,
  OtherLocationSettings,
  ReservationRestrictions,
  LocationRestrictionHolder,
  LocationDisplayGroup,
  VisitTypeEntity,
} from '../../../../types';
import { required, minLength, requiredIf } from 'vuelidate/lib/validators';

const apiBaseURL = process.env.VUE_APP_API_URL || '';
const webBaseURL = process.env.VUE_APP_BASE_URL || '';
const reservationURL = process.env.VUE_APP_RESERVATION_API_URL || '';
const reservationAppId = process.env.VUE_APP_RESERVATION_APP_ID || '';
export default Vue.extend({
  name: 'reservation-form',
  components: {
    Datepicker,
  },
  data() {
    return {
      activePage: 0,
      submitted: false,
      todaysDateSelected: true,
      emailSelected: true,
      isNameReadonly: new URL(location.href).searchParams.get('name') ? true : false,
      isEmailReadonly: new URL(location.href).searchParams.get('email') ? true : false,
      lastEmailChecked: null as string | null,
      lastPhoneChecked: null as string | null,
      phoneValid: false,
      reservationRestrictionsEmail: {
        byLocation: null,
        byCustomer: null,
      } as ReservationRestrictions | null,
      reservationRestrictionsPhone: {
        byLocation: null,
        byCustomer: null,
      } as ReservationRestrictions | null,
      reservationForm: {
        date: null as any,
        location: '' as any,
        timeslot: '' as any,
        entrance: '' as any,
        visitType: '' as any,
        groupSize: '' as any,
        name: '',
        email: '',
        phone: '',
        notes: '',
        terms: '',
        fullTerms: '',
      
      },
      isSubmit: false
    };
  },
  validations: {
    reservationForm: {
      date: {
        required,
        afterOrMinDate(value, vm): boolean {
          return moment(value).isSameOrAfter(moment(this.minDate), 'day');
        },
        beforeOrMaxDate(value, vm): boolean {
          return moment(value).isSameOrBefore(moment(this.maxDate), 'day');
        },
        notDisabledDate(value, vm): boolean {
          return !this.disabledDates.dates.some((dateObject: Date) => moment(dateObject).isSame(moment(value), 'day'));
        },
      },
      location: {
        required,
        allowed(value, vm): boolean {
          return this.validLocations.map((location) => location.id).includes(value);
        },
        withinGeographicRadius(value, rm): boolean {
          return (
            !((this as any).userLatitude && (this as any).userLongitude) ||
            (this.location !== null &&
              (this.location.georestrictionRadius === 0 ||
                checkAllowedLocation((this as any).userLatitude, (this as any).userLongitude, this.location)))
          );
        },
      },
      timeslot: {
        required,
        allowed(value, vm): boolean {
          return this.validTimeslots.map((timeslot) => timeslot.id).includes(value);
        },
      },
      entrance: {
        required,
        allowed(value, vm): boolean {
          return this.validEntrances.map((entrance) => entrance.id).includes(value);
        },
      },
      visitType: {
        required: requiredIf(function(this: any): boolean {
          return this.visitTypeId;
        }),
        // allowed(value, vm): boolean {
        //   return this.validVisitTypes.map((visitType) => visitType.id).includes(value);
        // },
      },
      groupSize: {
        required,
        allowed(value, vm): boolean {
          return this.validGroupSizes.includes(value);
        },
      },
      name: {
        required,
        valid(value, vm): boolean {
          return typeof value === 'string' && validator.isLength(value, { min: 2, max: 64 });
        },
      },
      email: {
        requiredIf: requiredIf(function (this: any): boolean {
          return this.isDisabledEmailPhoneToggle((this as any).location) || this.emailSelected;
        }),
        valid(value, vm): boolean {
          return (!this.emailSelected ? !this.isDisabledEmailPhoneToggle((this as any).location) : !this.emailSelected) || validator.isEmail(value);
        },
      },
      phone: {
        requiredIf: requiredIf(function (this: any): boolean {
          return this.isDisabledEmailPhoneToggle((this as any).location) || !this.emailSelected;
        }),
        valid(value, vm): boolean {
          return (this.emailSelected ? !this.isDisabledEmailPhoneToggle((this as any).location) : this.emailSelected) || this.phoneValid;
        },
      },
      notes: {
        requiredIf: requiredIf(function (this: any): boolean {
          return this.location && this.location.notesRequired;
        }),
        valid(value, vm): boolean {
          return !this.location || !this.location.notesRequired || validator.isLength(value, { min: 1, max: 2048 });
        },
      },
      fullTerms: {
        requiredIf: requiredIf(function (this: any): boolean {
          return this.location && this.location.termsAndConditionsURL;
        }),
        checked(value, vm): boolean {
          return !this.location || !this.location.termsAndConditionsURL || value === true;
        },
      },
    },
  },
  computed: {
    currentDatepickerLanguage(): any {
      return datepickerLanguages[this.$root.$i18n.locale];
    },
    currentReservationDate(): string | Date {
      return this.reservationForm.date;
    },
    minDate(): string {
      return this.location && this.location.firstReservationDate
        ? moment
        .max([moment.tz(this.location.firstReservationDate, this.locationTimezoneName), moment.tz(this.locationTimezoneName)])
        .format('YYYY-MM-DD')
        : moment.tz(this.locationTimezoneName).format('YYYY-MM-DD');
    },
    maxDate(): string {
      return this.location
        ? moment
          .tz(this.locationTimezoneName)
          .add(this.location.advancedBookingDays, 'd')
          .format('YYYY-MM-DD')
        : '';
    },
    location(): LocationEntity | null {
      return this.validLocations.length === 1
        ? this.validLocations[0]
        : this.reservationForm.location !== ''
          ? (this as any).locations.find((location: LocationEntity) => location.id === this.reservationForm.location) || null
          : null;
    },
    locationTimezoneName(): string {
      return this.location ? getLocationTimezoneName(this.location) : '';
    },
    blackoutDates(): Date[] {
      return this.location ? (this.location.blackoutDates as string[]).map((blackoutDate: string) => moment(blackoutDate).toDate()) : [];
    },
    emailRestrictionsDisabledDates(): Date[] {
      if (
        this.reservationRestrictionsEmail === null ||
        (this.reservationRestrictionsEmail.byCustomer === null && this.reservationRestrictionsEmail.byLocation === null) ||
        !this.emailSelected
      ) {
        return [];
      } else {
        const maxDailyReservations = (this as any).occupantType ? (this as any).occupantType.maxActiveReservationsPerDay : null;

        if (this.reservationRestrictionsEmail.byCustomer) {
          return this.reservationRestrictionsEmail.byCustomer
            .filter((dateObject) => dateObject.numberOfReservations >= maxDailyReservations)
            .map((dateObject) => moment(dateObject.date).toDate());
        } else if (this.reservationRestrictionsEmail.byLocation) {
          if (this.reservationForm.location !== '') {
            const locationObject: LocationRestrictionHolder | null =
              this.reservationRestrictionsEmail.byLocation.find(
                (restrictions: LocationRestrictionHolder) => restrictions.locationId === this.reservationForm.location,
              ) || null;

            return locationObject
              ? locationObject.dates
                .filter((dateObject) => dateObject.numberOfReservations >= maxDailyReservations)
                .map((dateObject) => moment(dateObject.date).toDate())
              : [];
          } else {
            return [];
          }
        } else {
          return [];
        }
      }
    },
    phoneRestrictionsDisabledDates(): Date[] {
      if (
        this.reservationRestrictionsPhone === null ||
        (this.reservationRestrictionsPhone.byCustomer === null && this.reservationRestrictionsPhone.byLocation === null) ||
        this.emailSelected
      ) {
        return [];
      } else {
        const maxDailyReservations = (this as any).occupantType ? (this as any).occupantType.maxActiveReservationsPerDay : null;

        if (this.reservationRestrictionsPhone.byCustomer) {
          return this.reservationRestrictionsPhone.byCustomer
            .filter((dateObject) => dateObject.numberOfReservations >= maxDailyReservations)
            .map((dateObject) => moment(dateObject.date).toDate());
        } else if (this.reservationRestrictionsPhone.byLocation) {
          if (this.reservationForm.location !== '') {
            const locationObject: LocationRestrictionHolder | null =
              this.reservationRestrictionsPhone.byLocation.find(
                (restrictions: LocationRestrictionHolder) => restrictions.locationId === this.reservationForm.location,
              ) || null;

            return locationObject
              ? locationObject.dates
                .filter((dateObject) => dateObject.numberOfReservations >= maxDailyReservations)
                .map((dateObject) => moment(dateObject.date).toDate())
              : [];
          } else {
            return [];
          }
        } else {
          return [];
        }
      }
    },
    externalUserDisabledDates(): Date[] {
      const maxDailyReservations = (this as any).occupantType ? (this as any).occupantType.maxActiveReservationsPerDay : null;
      const limitByLocation = (this as any).occupantType && (this as any).occupantType.maxActiveByLocation;

      const externalUserReservationDates: Array<{
        date: string;
        numberOfReservations: number;
      }> = (this as any).externalUserReservations
        .filter(
          (externalUserReservation: ReservationEntity) =>
            externalUserReservation.type === 1 &&
            ((limitByLocation && externalUserReservation.locationId === this.reservationForm.location) || !limitByLocation),
        )
        .reduce((accum: Array<{ date: string; numberOfReservations: number }>, externalUserReservation: ReservationEntity) => {
          const dateString = moment(externalUserReservation.startDate).format('YYYY-MM-DD');

          const existingDateObject = accum.find((dateObject) => dateObject.date === dateString);

          if (existingDateObject) {
            existingDateObject.numberOfReservations += 1;
          } else {
            accum.push({
              date: dateString,
              numberOfReservations: 1,
            });
          }

          return accum;
        }, []);

      return externalUserReservationDates
        .filter((dateObject) => dateObject.numberOfReservations >= maxDailyReservations)
        .map((dateObject) => moment(dateObject.date).toDate());
    },
    disabledDates(): any {
      const dates = this.blackoutDates
        .concat(this.externalUserDisabledDates)
        .concat(this.datesAllTimeslotsFull)
        .concat(this.emailRestrictionsDisabledDates)
        .concat(this.phoneRestrictionsDisabledDates);

      return {
        to: moment(this.minDate).toDate(),
        ...(this.maxDate !== '' && {
          from: moment(this.maxDate)
            .add(1, 'day')
            .toDate(),
        }),
        dates,
      };
    },
    datesAllTimeslotsFull(): Date[] {
      if (this.location) {
        const dates: string[] = [];
        const datesToDisable: Date[] = [];

        const currDate = moment(this.minDate).subtract(1, 'day');
        const lastDate = moment(this.maxDate).add(1, 'day');

        while (currDate.add(1, 'day').diff(lastDate) < 0) {
          dates.push(currDate.clone().format('YYYY-MM-DD'));
        }

        dates.forEach((date) => {
          const validTimeslotsForDate = this.getValidTimeslotsForDate(date);

          if (validTimeslotsForDate.length === 0) {
            datesToDisable.push(moment(date).toDate());
          }
        });

        return datesToDisable;
      } else {
        return [];
      }
    },
    validGroupSizes(): number[] {
      if (this.location && this.reservationForm.timeslot !== '' && this.reservationForm.entrance !== '') {
        const groupSizeRange = rangeArray(this.location.minGroupSize, this.location.maxGroupSize);

        const currentTimeslot: TimeslotEntity = (this as any).timeslots.find(
          (timeslot: TimeslotEntity) => timeslot.id === this.reservationForm.timeslot,
        );
        const currentEntrance: EntranceEntity = (this as any).entrances.find(
          (entrance: EntranceEntity) => entrance.id === this.reservationForm.entrance,
        );

        const reservationDateObjectForTimeslot = currentTimeslot
          ? currentTimeslot.reservationDates!.find((dateItem) => moment(this.currentReservationDate).isSame(moment(dateItem.date), 'day'))
          : null;
        const reservationDateObjectForEntrance = currentEntrance
          ? currentEntrance.reservationDates!.find((dateItem) => moment(this.currentReservationDate).isSame(moment(dateItem.date), 'day'))
          : null;

        return groupSizeRange.filter((groupSize) => {
          const isTooLargeForTimeslot =
            reservationDateObjectForTimeslot &&
            currentTimeslot.maxOccupancy &&
            reservationDateObjectForTimeslot.numberOfOccupants + groupSize > currentTimeslot.maxOccupancy;

          const isTooLargeForEntrance =
            reservationDateObjectForEntrance &&
            currentEntrance.maxOccupancy &&
            reservationDateObjectForEntrance.numberOfOccupants + groupSize > currentEntrance.maxOccupancy;

          return !isTooLargeForTimeslot && !isTooLargeForEntrance;
        });
      } else if (this.location) {
        return rangeArray(this.location.minGroupSize, this.location.maxGroupSize);
      } else {
        return [];
      }
    },
    validLocationGroups(): LocationDisplayGroup[] | null {
      const groups: Array<{ name: string | null; locations: LocationEntity[] }> = this.validLocations.reduce(
        (accum: Array<{ name: string | null; locations: LocationEntity[] }>, location: LocationEntity) => {
          const existingEntry = accum.find((grouping) => grouping.name === location.groupName);

          if (existingEntry) {
            existingEntry.locations.push(location);
          } else {
            accum.push({
              name: location.groupName,
              locations: [location],
            });
          }

          return accum;
        },
        [],
      );

      if (groups.length === 1 && groups[0].name === null) {
        return null;
      } else {
        const existingOtherGroup = groups.find((group) => group.name && group.name.toLowerCase() === 'other');

        groups.forEach((group) => {
          if (group.name === null) {
            if (existingOtherGroup) {
              existingOtherGroup.locations = existingOtherGroup.locations.concat(group.locations);
            } else {
              group.name = 'Other';
            }
          }
        });

        return groups as LocationDisplayGroup[];
      }
    },
    validLocations(): LocationEntity[] {
      const maxActiveReservationsTotal = (this as any).occupantType ? (this as any).occupantType.maxActiveReservationsTotal : null;
      const limitByLocation = (this as any).occupantType && (this as any).occupantType.maxActiveByLocation;
      const reservationRestrictions: ReservationRestrictions | null = this.reservationRestrictionsEmail || this.reservationRestrictionsPhone;

      if (limitByLocation && maxActiveReservationsTotal && reservationRestrictions && reservationRestrictions.byLocation) {
        const totalReservationsByLocation: Array<{ locationId: number; numberOfReservations: number }> = reservationRestrictions.byLocation.reduce(
          (accum: Array<{ locationId: number; numberOfReservations: number }>, locationObject: LocationRestrictionHolder) => {
            const numberOfReservations = locationObject.dates.reduce(
              (accumInner: number, dateObject) => accumInner + dateObject.numberOfReservations,
              0,
            );

            accum.push({
              locationId: locationObject.locationId,
              numberOfReservations,
            });

            return accum;
          },
          [],
        );

        return (this as any).locations.filter((location: LocationEntity) => {
          const locationObject = totalReservationsByLocation.find((item) => item.locationId === location.id);

          return (
            location.maxOccupancy > 0 &&
            !location.newReservationsDisabled &&
            (!(this as any).visitType || (this as any).visitType.locationIds.includes(location.id)) &&
            location.status === 1 &&
            (!locationObject || (locationObject && locationObject.numberOfReservations < maxActiveReservationsTotal))
          );
        });
      } else {
        return (this as any).locations.filter(
          (location: LocationEntity) =>
            (!(this as any).visitType || (this as any).visitType.locationIds.includes(location.id)) &&
            location.maxOccupancy > 0 &&
            !location.newReservationsDisabled &&
            location.status === 1,
        );
      }
    },
    validTimeslots(): TimeslotEntity[] {
      return this.getValidTimeslotsForDate(this.currentReservationDate).sort((a, b) =>
        moment(`1970-01-01T${a.startTime}`).isBefore(moment(`1970-01-01T${b.startTime}`))
          ? -1
          : moment(`1970-01-01T${a.startTime}`).isAfter(moment(`1970-01-01T${b.startTime}`))
            ? 1
            : 0,
      );
    },
    validEntrances(): EntranceEntity[] {
      return (this as any).entrances.filter((entrance: EntranceEntity) => {
        const dateItemsForEntrance = entrance.reservationDates!.filter((dateItem) =>
          moment(this.currentReservationDate).isSame(moment(dateItem.date), 'day'),
        );

        const singleReservationDateItem = dateItemsForEntrance.find((dateItemInner) => dateItemInner.timeslotId === this.reservationForm.timeslot);

        return (
          this.location &&
          entrance.status === 1 &&
          entrance.locationId === this.location.id &&
          entrance.maxOccupancy !== 0 &&
          !(
            singleReservationDateItem &&
            entrance.maxOccupancy !== null &&
            singleReservationDateItem.numberOfOccupants + this.reservationForm.groupSize > entrance.maxOccupancy
          ) &&
          entrance.occupantTypeAssociations.find((association) => association.occupantTypeId === (this as any).occupantTypeId)
        );
      });
    },
    continueButtonEnabled(): boolean {
      return (
        this.currentReservationDate !== null &&
        this.reservationForm.location !== '' &&
        this.reservationForm.entrance !== '' &&
        this.reservationForm.timeslot !== '' &&
        this.reservationForm.groupSize !== ''
      );
    },
    reserveButtonEnabled(): boolean {
      return this.currentReservationDate !== null && this.reservationForm.location !== '' && this.reservationForm.entrance !== '';
    },
    publicOccupantTypeAvailable(): boolean {
      return (
        (this as any).occupantType &&
        (this as any).occupantType.alternativePublicOccupantTypeAPIKey !== null &&
        (this as any).occupantType.alternativePublicOccupantTypeId !== null
      );
    },
  },
  methods: {
    async updateEmailRestrictions(): Promise<void> {
      const currentEmail = this.reservationForm.email;

      if (currentEmail !== this.lastEmailChecked && this.emailSelected && validator.isEmail(currentEmail) && (this as any).occupantType) {
        this.lastEmailChecked = currentEmail;

        // (this as any).showLoader();

        const apiReturn = await apiGetRequest({
          apiKey: (this as any).apiKey || '',
          apiURL: `${apiBaseURL}customer/${(this as any).customerId}/occupantType/${(this as any).occupantType.id}/restrictions/email/${this.reservationForm.email
            }`,
        });

        if (apiReturn !== null) {
          this.reservationRestrictionsEmail = apiReturn;
        }

        (this as any).hideLoader();
      }
    },
    async updatePhoneRestrictions(): Promise<void> {
      const currentPhone = this.formatPhoneNumber(this.reservationForm.phone);

      if (currentPhone !== this.lastPhoneChecked && !this.emailSelected && this.phoneValid && (this as any).occupantType) {
        this.lastPhoneChecked = currentPhone;

        // (this as any).showLoader();

        const apiReturn = await apiGetRequest({
          apiKey: (this as any).apiKey || '',
          apiURL: `${apiBaseURL}customer/${(this as any).customerId}/occupantType/${(this as any).occupantType.id
            }/restrictions/phone/${currentPhone}`,
        });

        if (apiReturn !== null) {
          this.reservationRestrictionsPhone = apiReturn;
        }

        (this as any).hideLoader();
      }
    },
    isDisabledEmailPhoneToggle(location: LocationEntity) {
      return location && location.otherSettings && (location.otherSettings as any).disabledEmailPhoneToggle;
    },
    getValidTimeslotsForDate(date: string | Date): TimeslotEntity[] {
      if (date === null) {
        return [];
      }

      const dateString = moment(date).format('YYYY-MM-DD');

      return (this as any).timeslots.filter((timeslot: TimeslotEntity) => {
        const dateForTimeslot = timeslot.reservationDates!.find((dateItem) => moment(dateString).isSame(moment(dateItem.date), 'day'));

        const timeslotPast =
          this.currentReservationDate !== null &&
          this.todaysDateSelected &&
          moment
            .tz(this.locationTimezoneName)
            .isSameOrAfter(moment.tz(`${moment.tz(this.locationTimezoneName).format('YYYY-MM-DD')}T${timeslot.endTime}`, this.locationTimezoneName));

        const currentDOW: 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday' = moment
          .tz(dateString, this.locationTimezoneName)
          .format('dddd')
          .toLowerCase() as 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

        const schedule = timeslot.schedule as TimeslotSchedule;

        const inSchedule: boolean = schedule
          ? schedule.daysOfWeek
            ? schedule.daysOfWeek[currentDOW]
            : schedule.specificDates
              ? schedule.specificDates.includes(moment(dateString).format('YYYY-MM-DD'))
              : false
          : false;

        return (
          this.location &&
          (timeslot.locationId === this.location.id || timeslot.visitTypeId === this.reservationForm.visitType) &&
          !timeslotPast &&
          timeslot.status === 1 &&
          inSchedule &&
          !(dateForTimeslot && timeslot.maxOccupancy && dateForTimeslot.numberOfOccupants + this.reservationForm.groupSize > timeslot.maxOccupancy)
        );
      });
    },
    normalizeStartingDate(dateItem: string | Date): string | Date {
      return typeof dateItem === 'string' ? dateItem.substring(0, 10) : dateItem;
    },
    toggleEmail(newState: boolean): void {
      this.emailSelected = newState;
    },
    changePage(newPage: number): void {
      this.activePage = newPage;
    },
    formatPhoneNumber(rawPhoneNumber: string): string {
      const interimPhoneNumber = rawPhoneNumber.replace(/ /g, '').replace(/-/g, '');

      return interimPhoneNumber.includes('+') ? interimPhoneNumber : `+1${interimPhoneNumber}`;
    },
    handleSubmit(): void {
      this.submitted = true;
      
      

      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }
      this.createCustomerReservation();
    },
    async createCustomerReservation(): Promise<void> {
      try {
        this.isSubmit = true;
        (this as any).showLoader();
        const postBody: CreateRegularReservation = {
          entranceId: this.reservationForm.entrance,
          timeslotId: this.reservationForm.timeslot,
          occupantTypeId: (this as any).occupantTypeId,
          startDate: moment(this.currentReservationDate).format('YYYY-MM-DD'),
          numberOfOccupants: this.reservationForm.groupSize,
          ...((this as any).externalUserId && {
            externalUserId: (this as any).externalUserId,
          }),
          ...((this as any).fcmToken && {
            fcmToken: (this as any).fcmToken,
          }),
          ...(this.location!.captureName && {
            name: this.reservationForm.name,
          }),
          ...(this.location!.notesRequired && {
            notes: this.reservationForm.notes,
          }),
          ...((this as any).visitTypeId && {
            visitTypeId: this.reservationForm.visitType,
          }),
          ...((this.isDisabledEmailPhoneToggle((this as any).location) || this.emailSelected) && { email: this.reservationForm.email }),
          ...((this.isDisabledEmailPhoneToggle((this as any).location) || !this.emailSelected) && {
            phone: this.formatPhoneNumber(this.reservationForm.phone),
          }),
          ...((this as any).userLatitude &&
            (this as any).userLongitude && {
            userLatitude: (this as any).userLatitude,
          }),
          ...((this as any).userLatitude &&
            (this as any).userLongitude && {
            userLongitude: (this as any).userLongitude,
          }),
          termsAgreed: true,
          lang: this.$root.$i18n.locale,
        };

        const apiReturn: CreateRegularReservationAPIReturn = await apiPostRequest({
          apiKey: (this as any).apiKey || '',
          apiURL: `${apiBaseURL}customer/${(this as any).customerId}/location/${this.reservationForm.location}/reservation`,
          postBody,
        });
        if (apiReturn.success) {
          const newReservation = apiReturn.data;
          this.$store.commit('appData/SET_EXTERNAL_USER_RESERVATION', newReservation);
          try {
            const headers = {};
            console.log(reservationURL);
            const eventName = new URL(location.href).searchParams.get('eventName');
            const eventStartTime = new URL(location.href).searchParams.get('eventStartTime');
            //const eventLocation = new URL(location.href).searchParams.get('eventLocation');
            const eventLocation = this.reservationForm.location == "132" ? 'pdc' : 'pla';
            const firstName = new URL(location.href).searchParams.get('firstName');
            const lastName = new URL(location.href).searchParams.get('lastName');
            const IdToken = new URL(location.href).searchParams.get('IdToken');
            const eventCategory = new URL(location.href).searchParams.get('eventCategory');
            const eventLanguage = new URL(location.href).searchParams.get('lang');
            const appUserId = new URL(location.href).searchParams.get('userSub');
            if (IdToken) {
              const apiBody = {
                appUserId: appUserId,
                eventId: postBody.visitTypeId.toString(),
                eventDate: postBody.startDate,
                eventStartTime: decodeURIComponent(eventStartTime as any),
                eventName: decodeURIComponent(eventName as any),
                eventCategory: decodeURIComponent(eventCategory as any),
                eventLocation: decodeURIComponent(eventLocation as any),
                eventLanguage: eventLanguage == 'es' ? 'Spanish' : 'English',
                numberOfPeople: postBody.numberOfOccupants,
                mobilePhone: postBody.phone ? postBody.phone : '',
                firstName: decodeURIComponent(firstName as any),
                lastName: decodeURIComponent(lastName as any),
                email: postBody.email ? postBody.email : '',
                smsOptInConsent: this.reservationForm.terms ? true : false,
              };
              const apiReturn = await axios.post(reservationURL, apiBody, { headers });
              
            }
          } catch (e) {
            console.log(e);
            (this as any).hideLoader();
            this.isSubmit = false;
            if (e instanceof Error) {
              //alert(e.message);
              // (this as any).$Simplert.open({
              //   title: 'Error',
              //   message: e.message,
              //   type: 'warning',
              //   customCloseBtnText: this.$t('text.try_again'),
              //   customCloseBtnClass: 'btn primary-button',
              //   onClose: this.resetForm,
              // });
            }
          }
          (this as any).hideLoader();
          this.isSubmit = false;
          this.$router.push({
            name: 'thank-you',
            params: {
              reservationId: newReservation!.id.toString(),
              reservationLocationId: this.reservationForm.location.toString(),
              reservationTimeslotId: this.reservationForm.timeslot.toString(),
              reservationEntranceId: this.reservationForm.entrance.toString(),
            },
          });
        } else {
          this.isSubmit = false;
          console.log("failed due to success....");
          logError("there are issue in success..");
          (this as any).hideLoader();
          (this as any).$Simplert.open({
            title: this.$t('text.reservation_error'),
            message: this.$t('text.reservation_create_error_message'),
            type: 'warning',
            customCloseBtnText: this.$t('text.try_again'),
            customCloseBtnClass: 'btn primary-button',
            onClose: this.resetForm,
          });
        }
      } catch (e) {
        console.log("catch",e);
        (this as any).hideLoader();
        this.isSubmit = false;
        if (e instanceof Error) {
              console.log(e.message);
              //alert(e.message);
              // (this as any).$Simplert.open({
              //   title: 'Error',
              //   message: e.message,
              //   type: 'warning',
              //   customCloseBtnText: this.$t('text.try_again'),
              //   customCloseBtnClass: 'btn primary-button',
              //   onClose: this.resetForm,
              // });
        }
        logError(e);
        (this as any).$Simplert.open({
          title: this.$t('text.reservation_error'),
          message: this.$t('text.reservation_create_error_message'),
          type: 'warning',
          customCloseBtnText: this.$t('text.try_again'),
          customCloseBtnClass: 'btn primary-button',
          onClose: this.resetForm,
        });
      }
    },
    async resetForm(): Promise<void> {
      // (this as any).showLoader();

      await (this as any).getCustomerData();
      await (this as any).getLocationData(this.reservationForm.location, false, true, (this as any).visitTypeId);

      const admit = this.checkOccupantTypePermissions();

      if (!admit) {
        this.openNotAllowedModal();
      }

      if (this.disabledDates.dates.some((dateObject: Date) => moment(dateObject).isSame(moment(this.currentReservationDate), 'day'))) {
        this.reservationForm.date = null;
      }

      (this as any).hideLoader();
    },
    async setInitialValues(): Promise<void> {
      if (this.validLocations && this.validLocations.length === 1) {
        this.reservationForm.location = this.validLocations[0].id;

        (this as any).showLoader();

        await (this as any).getLocationData(this.reservationForm.location, false, false, (this as any).visitTypeId);

        (this as any).hideLoader();
      }

      const location: LocationEntity | null =
        this.location || this.validLocations.find((validLocation) => validLocation.id === this.reservationForm.location) || null;

      if (location) {
        if (location.translations) {
          (this as any).setTranslations(location.translations, this.$root.$i18n.locale);
        }

        if (location.visualSettings) {
          (this as any).setVisualSettings(location.visualSettings);

          this.$root.$emit('setLogo', location.logoURL);
        }
      } else {
        const locationVisualFallback = this.validLocations.find(
          (validLocation) => validLocation.visualSettings && validLocation.visualSettings !== null,
        );

        if (locationVisualFallback) {
          (this as any).setVisualSettings(locationVisualFallback.visualSettings);
        }

        const locationTranslationsFallback = this.validLocations.find(
          (validLocation) => validLocation.translations && validLocation.translations !== null,
        );

        if (locationTranslationsFallback) {
          (this as any).setTranslations(locationTranslationsFallback.translations);
        }
      }

      this.reservationForm.date = null;

      const recommendedEntrance = getLowestUtilizedEntrance(this.validEntrances);

      this.reservationForm.entrance = recommendedEntrance ? recommendedEntrance.id : '';

      this.reservationForm.groupSize = this.validGroupSizes.length === 1 ? this.validGroupSizes[0] : '';

      this.reservationForm.name = (this as any).externalUserName || (this as any).queryParametersName || '';
      this.reservationForm.email = (this as any).externalUserEmail || (this as any).queryParametersEmail || '';
      this.reservationForm.phone = (this as any).externalUserPhone || '';

      if (this.reservationForm.email !== '') {
        this.updateEmailRestrictions();
      } else if (this.reservationForm.phone !== '') {
        this.updatePhoneRestrictions();
      }

      this.reservationForm.visitType = (this as any).visitTypeId || '';
    },
    checkOccupantTypePermissions(): boolean {
      if ((this as any).occupantType && !(this as any).occupantType.manualAccess) {
        return true;
      }

      const manualGroupReservation: ReservationEntity = (this as any).externalUserReservations.find(
        (externalUserReservation: ReservationEntity) =>
          externalUserReservation.type === 2 && externalUserReservation.occupantTypeId === (this as any).occupantTypeId,
      );

      return (
        typeof manualGroupReservation !== 'undefined' &&
        (manualGroupReservation.manualGroup!.expirationDate === null ||
          moment.tz(this.locationTimezoneName).isBefore(moment.tz(manualGroupReservation.manualGroup!.expirationDate, this.locationTimezoneName)))
      );
    },
    openNotAllowedModal(): void {
      (this as any).$Simplert.open({
        title: this.$t('text.not_allowed'),
        message: `${this.$t('text.not_allowed_message')} ${this.publicOccupantTypeAvailable ? this.$t('text.please_click_continue') : this.$t('text.please_contact_location')
          }`,
        type: 'warning',
        customCloseBtnText: this.publicOccupantTypeAvailable ? this.$t('text.continue') : this.$t('text.close'),
        customCloseBtnClass: 'btn primary-button',
        onClose: this.goToPublicOccupantType,
      });
    },
    goToPublicOccupantType(): void {
      if (this.publicOccupantTypeAvailable) {
        const link = this.$router.resolve({
          name: 'reserve',
          query: {
            apiKey: (this as any).occupantType.alternativePublicOccupantTypeAPIKey,
            customerId: (this as any).customerId,
            occupantTypeId: (this as any).occupantType.alternativePublicOccupantTypeId,
            lang: (this as any).lang,
            webview: (this as any).webview,
            primaryColor: (this as any).primaryColor.replace('#', ''),
            primaryFontColor: (this as any).primaryFontColor.replace('#', ''),
            primaryButtonFontColor: (this as any).primaryButtonFontColor.replace('#', ''),
            secondColor: (this as any).secondColor.replace('#', ''),
            secondFontColor: (this as any).secondFontColor.replace('#', ''),
            secondButtonFontColor: (this as any).secondButtonFontColor.replace('#', ''),
            thirdColor: (this as any).thirdColor.replace('#', ''),
            thirdFontColor: (this as any).thirdFontColor.replace('#', ''),
            thirdButtonFontColor: (this as any).thirdButtonFontColor.replace('#', ''),
            fourthColor: (this as any).fourthColor.replace('#', ''),
            fourthFontColor: (this as any).fourthFontColor.replace('#', ''),
            fourthButtonFontColor: (this as any).fourthButtonFontColor.replace('#', ''),
            headerBackgroundColor: (this as any).headerBackgroundColor.replace('#', ''),
            languagePickerColor: (this as any).languagePickerColor.replace('#', ''),
            ...((this as any).externalUserId && {
              externalUserId: (this as any).externalUserId,
            }),
            ...((this as any).widgetLayout && {
              widgetLayout: (this as any).widgetLayout,
            }),
            ...((this as any).cssURL && { cssURL: (this as any).cssURL }),
            ...((this as any).visitTypeId && { visitTypeId: (this as any).visitTypeId }),
            ...((this as any).fcmToken && { fcmToken: (this as any).fcmToken }),
            ...((this as any).queryParametersName && { name: (this as any).queryParametersName }),
            ...((this as any).queryParametersEmail && { email: (this as any).queryParametersEmail }),
          },
        });

        window.location.assign(link.href);
      } else {
        this.$router.go(0);
      }
    },
  },
  created() {
    this.activePage = (this as any).widgetLayout === '1-col-short' || (this as any).webview ? 1 : 0;
  },
  mounted() {
    this.setInitialValues();

    const admit = this.checkOccupantTypePermissions();

    if (!admit) {
      this.openNotAllowedModal();
    }
  },
  watch: {
    webview(newVal) {
      this.activePage = newVal ? 1 : 0;
    },
    widgetLayout(newVal) {
      this.activePage = newVal === '1-col-short' ? 1 : 0;
    },
    emailRestrictionsDisabledDates(newVal) {
      if (newVal.some((dateObject: Date) => moment(dateObject).isSame(moment(this.currentReservationDate), 'day'))) {
        this.reservationForm.date = null;
      }
    },
    phoneRestrictionsDisabledDates(newVal) {
      if (newVal.some((dateObject: Date) => moment(dateObject).isSame(moment(this.currentReservationDate), 'day'))) {
        this.reservationForm.date = null;
      }
    },
    currentReservationDate(newVal) {
      this.todaysDateSelected = moment.tz(newVal, this.locationTimezoneName).isSame(moment.tz(this.locationTimezoneName), 'day');

      this.reservationForm.timeslot = this.validTimeslots.length === 1 ? this.validTimeslots[0].id : '';
    },
    async location(newVal, oldVal) {
      if ((oldVal === null && newVal !== null) || (oldVal !== null && newVal !== null && newVal.id !== oldVal.id)) {
        this.submitted = false;

        if ((this as any).locationId === null) {
          // (this as any).showLoader();
          await (this as any).getLocationData(newVal.id, false, false, (this as any).visitTypeId);
          (this as any).hideLoader();
          const mall = new URL(location.href).searchParams.get('mall');
        }

        this.setInitialValues();
      }
    },
    externalUserName(newVal) {
      this.reservationForm.name = newVal;
    },
    externalUserEmail(newVal) {
      this.reservationForm.email = newVal;
    },
    externalUserPhone(newVal) {
      this.reservationForm.phone = newVal;
    },
  },
});
